import { render, staticRenderFns } from "./contact_us.vue?vue&type=template&id=97fae92a&scoped=true&"
import script from "./contact_us.vue?vue&type=script&lang=js&"
export * from "./contact_us.vue?vue&type=script&lang=js&"
import style0 from "./contact_us.vue?vue&type=style&index=0&id=97fae92a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97fae92a",
  null
  
)

export default component.exports